import styles from '../styles/Question.module.scss';
import {QuestionBlock, QuestionItem} from "../services/types";
import Button from "./Button";
import React, {useEffect, useRef, useState} from "react";
import MessageBubble from "./MessageBubble";

interface PCWindowProps {
    title: string,
    result: string,
    answers: QuestionItem[],
    onClickNext: () => void;
    onClickNextCorrect: () => void;
}


const Question: React.FC<PCWindowProps> = ({ title, result, answers, onClickNext, onClickNextCorrect }) =>  {
    const [qAnswers, setQAnswers] = useState<QuestionItem[]>([]);
    const [btnText, setBtnText] = useState<string>("Готово");
    const [isCorrect, setIsCorrect] = useState<boolean>(false);

    useState(() => {
        setQAnswers(answers)
    });

    const handleClick = (index: number) => {
        setQAnswers(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, selected: !item.selected } : item
            )
        );
    }
    const handleBtnClick = () => {
        setBtnText("Далее")
        var correctCnt = 0
        var selectCnt = 0
        var fullCorrectCnt = 0
        for (var i = 0; i< qAnswers.length; i++){
            if (qAnswers[i].correct){
                fullCorrectCnt++
            }
            if (qAnswers[i].selected){
                selectCnt++
                if (qAnswers[i].correct){
                    correctCnt++
                }
            }
        }
        // console.log(fullCorrectCnt)
        if (selectCnt === correctCnt && selectCnt === fullCorrectCnt){
            setIsCorrect(true)
        }
    }
    return (
        <div className={styles.Question}>
            <div className={styles.QuestionBlock}>
                <b className={styles.Title} dangerouslySetInnerHTML={{ __html: title }}></b>
                <div className={styles.QuestionBlockItems}>
                    {qAnswers!.map((answer, index) => (
                        <div className={styles.Answer} style={{
                            ...(answer.selected && {background: '#455BC1'}),
                            ...((btnText === "Далее" && answer.correct) && {background: '#41951F'}),
                            ...((btnText === "Далее" && answer.selected && !answer.correct) && {background: '#BC2B2B'})
                        }} dangerouslySetInnerHTML={{ __html: answer.name }} onClick={() => handleClick(index)}></div>
                    ))}
                </div>
            </div>
            {btnText === "Далее" && (
                <MessageBubble label={''} positionTop={false}
                               text={result} textHeight={''}
                               textIsMaxSize={false}
                               bitTitle={false}/>
            )}
            <div className={styles.stepButtons}>
                {btnText !== "Далее" ?
                    <Button
                        label={btnText}
                        redColor={false}
                        answered={false}
                        width={"262px"}
                        onClick={() => handleBtnClick()}
                    />
                    :
                    <Button
                        label={btnText}
                        redColor={false}
                        answered={false}
                        width={"262px"}
                        onClick={isCorrect ? onClickNextCorrect : onClickNext}
                    />
                }

            </div>
        </div>
    );
}


export default Question;
